import { StyleSheet } from 'react-native';
import { themes } from '../../theme/theme';

export const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-around',
  },
  bottomTabs: {},
  tab: {
    paddingVertical: 12,
    alignItems: 'center',
  },
  activeTab: {
    borderBottomWidth: 3,
    borderRadius: 2,
    borderColor: themes.light.gray_blue[1], // Active indicator color
  },
  disabledTab: {
    opacity: 0.5,
  },
});
